// extracted by mini-css-extract-plugin
module.exports = {"module":"PageLoading_module__uB8vU","inner":"PageLoading_inner__3Gi_Z","icon":"PageLoading_icon__3XZYy"};